const VIEWPORT_PADDING_PX = 8;
const SUBMENU_GAP_PX = 2;

export type AnchorRect = {
  left: number;
  right: number;
  top: number;
  bottom: number;
};

export type ClampedMenuPosition = {
  x: number;
  y: number;
};

type MenuSize = {
  width: number;
  height: number;
};

type ViewportSize = {
  width: number;
  height: number;
};

function getViewportSize(): ViewportSize {
  return {
    width: window.innerWidth,
    height: window.innerHeight
  };
}

function clampWithin(value: number, min: number, max: number): number {
  if (max < min) {
    return min;
  }
  if (value < min) {
    return min;
  }
  if (value > max) {
    return max;
  }
  return value;
}

export function clampCursorMenuToViewport(
  cursor: { x: number; y: number },
  menuSize: MenuSize,
  viewport: ViewportSize = getViewportSize()
): ClampedMenuPosition {
  const minX = VIEWPORT_PADDING_PX;
  const maxX = viewport.width - menuSize.width - VIEWPORT_PADDING_PX;
  const minY = VIEWPORT_PADDING_PX;
  const maxY = viewport.height - menuSize.height - VIEWPORT_PADDING_PX;

  const overflowsRight =
    cursor.x + menuSize.width + VIEWPORT_PADDING_PX > viewport.width;
  const overflowsBottom =
    cursor.y + menuSize.height + VIEWPORT_PADDING_PX > viewport.height;

  const flippedX = overflowsRight ? cursor.x - menuSize.width : cursor.x;
  const flippedY = overflowsBottom ? cursor.y - menuSize.height : cursor.y;

  return {
    x: clampWithin(flippedX, minX, maxX),
    y: clampWithin(flippedY, minY, maxY)
  };
}

export function clampAnchoredSubmenuToViewport(
  anchor: AnchorRect,
  menuSize: MenuSize,
  viewport: ViewportSize = getViewportSize()
): ClampedMenuPosition {
  const minX = VIEWPORT_PADDING_PX;
  const maxX = viewport.width - menuSize.width - VIEWPORT_PADDING_PX;
  const minY = VIEWPORT_PADDING_PX;
  const maxY = viewport.height - menuSize.height - VIEWPORT_PADDING_PX;

  const preferredRight = anchor.right + SUBMENU_GAP_PX;
  const flippedLeft = anchor.left - menuSize.width - SUBMENU_GAP_PX;

  const overflowsRight =
    preferredRight + menuSize.width + VIEWPORT_PADDING_PX > viewport.width;

  const desiredX = overflowsRight ? flippedLeft : preferredRight;

  return {
    x: clampWithin(desiredX, minX, maxX),
    y: clampWithin(anchor.top, minY, maxY)
  };
}
